import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { FundingSourceDto } from '~/models/modules/Asset/fundingSource';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class FundingSourceService extends ApiServiceBase {
  fundingSourceAdded: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }




  getFundingSourceGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }

  // getFundingSourceListing(model: any = null){
  //   return this.http.get<FundingSourceDto[]>(this._url());
  // }
  getFundingSourceListing(model: any = {}){
    return this.http.post<FundingSourceDto[]>(this._url(`/fundingSourceListing`), model);
  }

  getFundingSourceById(id : number){
    return this.http.get<FundingSourceDto>(this._url(`/${id}`));
  }
  isRelated(id: number) {
    return this.client.post<boolean>(this._url(`/is-related/${id}`), null);
  }
  createFundingSource(model : any){
    return this.client.post<FundingSourceDto>(this._url(), model);
  }

  updateFundingSource(id: number, model : any){
    return this.client.put<any>(this._url(`/${id}`), model);
  }

  deactivateFundingSource(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  deactivateFundingSourceBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivateFundingSource(id: number) {
    return this.client.put(this._url(`/reactivate/${id}`), null);
  }
  reactivateFundingSourceBatch(obj: any) {
    return this.client.put(this._url(`/reactivate-batch`), obj);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/FundingSources${v}`);
  }
}
